import { Schema } from "nutso";
import { Org } from "../models/Org";

export const orgSchema: Schema<Org, any, any> = {
  type: "object",
  properties: {
    id: {
      type: "string",
    },
    createdIsoDateTimeUtc: {
      type: "string",
    },
    updatedIsoDateTimeUtc: {
      type: "string",
    },
    name: {
      type: "string",
    },
    logo: {
      type: "object",
      optional: true,
      properties: {
        id: {
          type: "string",
        },
        path: {
          type: "string",
        },
      },
    },
    createdByUid: {
      type: "string",
    },
    domain: {
      type: "string",
    },
  },
};
